(async () => {
    const { Core } = await importModule('Core');
    const { $show } = await importModule('Utils');

    const CN_EXPANDED = '!expanded';
    const EXPAND_THRESHOLD = 100;

    customElements.define('product-description-expand', class extends Core {
        elements = {
            content: '[data-content]',
            link: '[data-expand-link]'
        }

        render() {
            const contentHeight = this.$content.offsetHeight;
            if(contentHeight > EXPAND_THRESHOLD * 1.25) {
                this.classList.remove(CN_EXPANDED);
                this.style.setProperty('--expand-height', `${EXPAND_THRESHOLD}px`);
                $show(this.$link);

                
                this.$link.childNodes.forEach(node => {
                    if(node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
                        const span = document.createElement('span');
                        span.setAttribute('data-label', '');
                        span.textContent = node.textContent.trim();
                        node.replaceWith(span);
                    }
                });

this.$link.addEventListener('click', () => {
    const isClosed = this.classList.toggle(CN_EXPANDED);
    console.log('isClosed:', isClosed, 'classes:', this.className);
    const label = this.$link.querySelector('[data-label]');
    if(label) label.textContent = isClosed ? '閉じる' : '続きを読む';
})
            }
        }
    })
})();